import { Injectable } from '@angular/core';
import { ComponentItem, Page, Section, WebElement } from '../../state-management/model/interfaces/state.model';
import { WebsiteStateService } from '../../state-management/services/website-state.service';
import { v4 as uuidv4 } from 'uuid';
import { ButtonActionType, ComponentType, ElementsType } from '../../state-management/model/enums/state.enums';

@Injectable({
  providedIn: 'root'
})
export class PageTemplateService {

  constructor(private websiteState: WebsiteStateService) { }


  public createTemplate(page: Page): void {
    const heroComponentSet = this.createHeroComponent();
    const navbarComponentId = "c6f25ff1-3c1e-4bcb-a903-b834d6853517"
    const heroSection = {
      "id": uuidv4(),
      "type": "hero",
      "order": 1,
      "components": [
        heroComponentSet.component.id,
        navbarComponentId
      ]
    }

    this.websiteState.addSection(heroSection.id, heroSection);
    this.websiteState.addComponent(heroComponentSet.component.id, heroComponentSet.component);
    heroComponentSet.elements.forEach((element) => {
      this.websiteState.addElement(element.id, element);
    });

    const featureBannerId = "27089719-5a31-4026-b893-8e91c1808652"
    const serviceComponents = [featureBannerId];
    for (let i = 0; i < 4; i++) {
      const serviceComponent = this.createServiceComponent(i);
      serviceComponents.push(serviceComponent.component.id);
      this.websiteState.addComponent(serviceComponent.component.id, serviceComponent.component);
      serviceComponent.elements.forEach((element) => {
        this.websiteState.addElement(element.id, element);
      });
    }
    const contactFormId = "6014e702-b4f1-4dfa-84db-49fd8275d224"
    serviceComponents.push(contactFormId);

    const serviceSection: Section = {
      "id": uuidv4(),
      "type": "section-services",
      "order": 1,
      "components": serviceComponents
    }
    this.websiteState.addSection(serviceSection.id, serviceSection);
    this.websiteState.addPage(page.id, { ...{ sections: [heroSection.id, serviceSection.id] }, ...page });
  }


  private createServiceComponent(i: number): { component: ComponentItem, elements: WebElement[] } {

    // ### Service Elements ###
    const elements: WebElement[] = [
      {
        "type": ElementsType.ComponentHeader,
        "value": `Überschrift des Servicebereichs ${i+1}`,
        "tag": "h2",
        "id": uuidv4(),
        "styles": null,
        "label": "title"
      },
      {
        "type": ElementsType.ComponentHeader,
        "value": `Untertitel des Servicebereichs ${i+1}`,
        "tag": "h4",
        "id": uuidv4(),
        "styles": null,
        "label": "subtitle"
      },
      {
        "type": ElementsType.ServiceDetails,
        "value": "Kontaktieren Sie uns",
        "tag": "mat-flat-button",
        "id": uuidv4(),
        "styles": null,
        "label": "contactButton",
        "buttonConfig": {
          "type": ButtonActionType.ScrollTo as ButtonActionType.ScrollTo,
          "params": {
            "target": "32219a97-a536-43d4-b9b5-748cba013ab2"
          }
        }
      },
      {
        "type": ElementsType.ServiceDetails,
        "value": "Erkläre Sie an dieser Stelle Ihren Kunden, was Sie anbieten",
        "tag": "p",
        "id": uuidv4(),
        "styles": null,
        "label": "text"
      },
      {
        "type": ElementsType.ServiceDetails,
        "value": null,
        "tag": "img",
        "id": uuidv4(),
        "styles": null,
        "label": "image",
        "options": {
          "altText": "Beschreibung des Bildes"
        }
      }
    ]

    // ### Service Components ###
    const component: ComponentItem = {
      "id": uuidv4(),
      "type": ComponentType.ServiceDetails,
      "order": 1,
      "elements": elements.map(element => element.id)
    }

    return { component, elements };
  }

  private createHeroComponent(): { component: ComponentItem, elements: WebElement[] } {
    const elements: WebElement[] = [
      {
        "type": ElementsType.Text,
        "value": "Überschrift",
        "tag": "h1",
        "id": uuidv4(),
        "styles": null,
        "label": "title"
      },
      {
        "type": ElementsType.Text,
        "value": "Untertitel",
        "tag": "p-large",
        "id": uuidv4(),
        "styles": null,
        "label": "subtitle"
      },
      {
        "type": ElementsType.Button,
        "value": "Jetzt kontaktieren",
        "tag": "mat-flat-button",
        "id": uuidv4(),
        "styles": null,
        "label": "highlight-button",
        // "buttonConfig": {
        //   "type": ButtonActionType.Navigate as ButtonActionType.Navigate,
        //   "params": {
        //     "url": "service/hochzeiten"
        //   }
        // }
      },
      {
        "type": ElementsType.Button,
        "value": "Unsere Services",
        "tag": "mat-raised-button",
        "id": uuidv4(),
        "styles": null,
        "label": "secondary-button",
        "buttonConfig": {
          "type": ButtonActionType.ScrollTo as ButtonActionType.ScrollTo,
          "params": {
            "target": "32219a97-a536-43d4-b9b5-748cba013ab2"
          }
        }
      },
      {
        "type": ElementsType.Image,
        "value": null,
        "tag": "img",
        "id": uuidv4(),
        "styles": null,
        "label": "hero-image",
        "options": {
          "altText": "Bilder für Hochzeit"
        }
      }
    ]

    const component: ComponentItem = {
      "id": uuidv4(),
      "type": ComponentType.Hero,
      "order": 1,
      "elements": elements.map(element => element.id)
    }
    return { component, elements };
  }


}
